import { Brand } from '@shared-utils/types/common.types';
export const getAgencyProximity = (distance) => {
    if (distance >= 100 && distance < 500) {
        return '500 m';
    }
    else if (distance < 100) {
        return '100 m';
    }
    return `${Math.ceil(distance / 1000)} km`;
};
export const getAgencyRating = (rating, brand) => {
    switch (brand) {
        case Brand.IWB:
            return Number((rating / 20).toFixed(1));
        default:
            return Number(rating.toFixed(1));
    }
};
export const formatLengthAgencyName = (name) => {
    const charactersLimit = 50;
    if (name.length <= charactersLimit) {
        return name;
    }
    return name.slice(0, charactersLimit) + '...';
};
export const formatAgencyName = (name) => {
    return name
        .toLowerCase()
        .split(' ')
        .map((word) => {
        return (word.charAt(0).toUpperCase() + word.slice(1))
            .split(/(['-]+)/)
            .map((word) => {
            return word.length > 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word;
        })
            .join('');
    })
        .join(' ');
};
